// ============================================================================
// VYVA Onboarding Portal - Sidebar Component
// ============================================================================

import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  Phone, 
  BarChart3, 
  Settings, 
  Upload,
} from 'lucide-react';
import { cn } from './ui/utils';

// ============================================================================
// Navigation Items
// ============================================================================
const navItems = [
  { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard' },
  { icon: Upload, label: 'Bulk Onboarding', path: '/bulk-onboarding' },
  { icon: Users, label: 'Users', path: '/users' },
  { icon: Phone, label: 'Calls Queue', path: '/calls' },
  { icon: BarChart3, label: 'Reports', path: '/reports' },
  { icon: Settings, label: 'Settings', path: '/settings' },
];

// ============================================================================
// Component
// ============================================================================
export function Sidebar() {
  const location = useLocation();

  return (
    <aside className="w-64 border-r border-border bg-sidebar h-full flex flex-col">
      <nav className="flex-1 px-4 py-8">
        <ul className="space-y-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path || 
              (item.path !== '/dashboard' && location.pathname.startsWith(item.path));
            
            return (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={cn(
                    'w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all',
                    isActive
                      ? 'bg-sidebar-accent text-sidebar-accent-foreground shadow-sm'
                      : 'text-sidebar-foreground hover:bg-sidebar-accent/10 hover:text-sidebar-accent'
                  )}
                >
                  <Icon className="h-5 w-5" />
                  <span>{item.label}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
}

export default Sidebar;
